import React from 'react'
import useTranslation from 'next-translate/useTranslation'
import Link from 'next/link'
import {
  InfoWrapper,
  DesktopHeroWrapper,
  Spacer,
  Description,
  HeroHeader,
} from '../../../Essentials/components/Hero/Hero.styles'
import {
  MobileWrapper,
  DesktopWrapper,
} from 'features/components/ProductDetailHero/ProductDetailHero.styles'
import { Text } from 'components/Text'
import { Stack } from 'components/Stack'
import { HeroImage } from 'features/components/ProductDetailHero/components/HeroImage'
import { InformationCollapse, InformationCollapseType } from 'features/components/ProductDetailHero/components/InformationCollapse'
import { Button } from 'components/Button'
import Trans from 'next-translate/Trans'
import { HeroTitle } from 'features/components/ProductDetailHero/components/HeroHeader/HeroHeader.styles'
import thumbnail from '../../../../../../../../public/assets/product/treats-short.webp'
import { ProductDetailHero } from 'features/components/ProductDetailHero'
import { HeroRoot, ContentContainer } from '../../../Startr/components/Hero/Hero.styles'

type HeroProps = {}

export const Hero = ({}: HeroProps) => {
  const { t } = useTranslation()

  const infoList: InformationCollapseType[] = [
    {
      label: 'products:treats.hero.ingredients.label',
      description: 'products:treats.hero.ingredients.description',
    },
    {
      label: 'products:treats.hero.nutrition.label',
      description: 'products:treats.hero.nutrition.description',
    },
  ]

  return (
    <HeroRoot>
      <ProductDetailHero>
        <DesktopHeroWrapper>
          <HeroImage thumbnail={thumbnail} alt={t('products:treats.hero.imageAlt')} />
        </DesktopHeroWrapper>
        <ContentContainer>
          <Stack direction="column" alignItems="center" gap={{ '@initial': '2', '@bp3': '5' }}>
            <HeroHeader>
              <HeroTitle>{t('products:treats.hero.title')}</HeroTitle>
              <Description
                css={{
                  maxWidth: '300px',
                  '@bp3': { maxWidth: '560px' },
                }}
                align="center"
                size={{ '@initial': 'body', '@bp3': 'bodyLarge' }}
                color="accent-black"
              >
                <Trans i18nKey={'products:treats.hero.subtitle'} components={{ br: <br /> }} />
              </Description>
            </HeroHeader>
            <MobileWrapper>
              <HeroImage thumbnail={thumbnail} alt={t('products:treats.hero.imageAlt')} />
            </MobileWrapper>

            <Stack gap='2' direction="column" alignItems="center" width="fullWidth">
              <Text
                align="center"
                size={{ '@initial': 'body', '@bp3': 'bodyLarge' }}
                color="accent-black"
                css={{maxWidth: '300px', '@bp3': { maxWidth: '100%' }}}
              >
                {t('products:treats.hero.disclaimer')}
              </Text>
              <Link href="/user">
                <Button>
                  {t('products:treats.hero.cta')}
                </Button>
              </Link>
            </Stack>
          </Stack>

          <Spacer />

          <InfoWrapper>
            <InformationCollapse infoList={infoList} />
          </InfoWrapper>
        </ContentContainer>
      </ProductDetailHero>
    </HeroRoot>
  )
}

Hero.displayName = 'Hero'
